import _ from "lodash-es";
import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import ProductListForm from "@/lib/form/bgcheck/ProductListForm";
import SendBgCheckMessageForm from "@/lib/form/bgcheck/SendBgCheckMessageForm";

export default class BgCheck extends Model {
  // 查询背调服务购买状态
  static BgcheckProductList(productListForm: ProductListForm) {
    return request
      .post("/aiExam/company/bgCheckProductList", productListForm)
      .then(resp => {
        return resp.data;
      });
  }

  // 发送背调通知
  static SendBgCheckMessage(sendBgCheckMessageForm: SendBgCheckMessageForm) {
    return request
      .post("/aiExam/candidate/sendBgCheckMessage", sendBgCheckMessageForm)
      .then(resp => {
        return resp.data;
      });
  }
}

export class BgCheckProduct {
  productId = 0; //背调产品ID
  afterBuy = 0; //是否购买
  identityInfo = 0; //身份信息验证
  socialInfo = 0; //社会不良信息
  financialRisk = 0; //金融风险
}
